import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AolService {
  baseUrl: string = environment.API_SERVER;
  payment: any;
  constructor(private _http: HttpClient) {}

  getFinancialEnd(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/get-year-end/?organizationId=${payload.organizationId}`,
      payload.body
    );
  }
  createFinancialEnd(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-update-year-end/`,
      payload.body
    );
  }
  getAllFinancialEnd(payload) {
    return this._http.get(
      this.baseUrl + `/organizations/aol/financial-years/`,
      { params: payload.params }
    );
  }
  createNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-finance-network-operator/`,
      payload.body
    );
  }
  editNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-details/`,
      payload.body
    );
  }
  uploadAOLDocuments(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-document/`,
      payload.body
    );
  }

  getOrganizationAol(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/${payload.organizationId}/details/`,
      {
        params: payload.params,
      }
    );
  }
  getOrganizationAolSummary(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/${payload.organizationId}/summary/`,
      {
        params: payload.params,
      }
    );
  }
  getOrganizationAolDetails(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/${payload.organizationAolId}/aol-details/`,
      {
        params: payload.params,
      }
    );
  }

  getSubmittedOrg(payload) {
    return this._http.get(`${this.baseUrl}/organizations/aol/submitted-orgs/`, {
      params: payload.params,
    });
  }
  getDocuments(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/documents/?organizationAolId=${payload.organizationAolId}`
    );
  }
  deleteDocuments(payload) {
    return this._http.delete(
      `${this.baseUrl}/organizations/aol/delete-document/?aolDocumentId=${payload.aolDocumentId}`
    );
  }
  updateDocument(payload) {
    return this._http.put(
      `${this.baseUrl}/organizations/aol/update-document/?aolDocumentId=${payload.aolDocumentId}`,
      payload.body
    );
  }

  createFinanceNonNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-finance-non-network-operator/`,
      payload.body
    );
  }
  createFinanceNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-finance-network-operator/`,
      payload.body
    );
  }
  editFinanceNonNetworkAssessment(payload) {
    return this._http.put(
      `${this.baseUrl}/organizations/aol/update-finance-non-network-operator/?nonNetworkOperatorAssessmentId=${payload.nonNetworkOperatorAssessmentId}`,
      payload.body
    );
  }
  editFinanceNetworkAssessment(payload) {
    return this._http.put(
      `${this.baseUrl}/organizations/aol/update-finance-network-operator/?networkOperatorAssessmentId=${payload.networkOperatorAssessmentId}`,
      payload.body
    );
  }
}
